module.exports = __webpack_public_path__ + "img/scales-01.df3e15a1.svg";